<template>
  <section class="app-main">
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <router-view
        :key="key"
      />
    </transition>
  </section>
</template>

<script>

export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 180px);
  width: calc(100% - 28px);
  position: relative;
  overflow: hidden;
  padding: 14px;
  background-image: url('../../assets/images/CommonBackground.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 180px);
  }

  .fixed-header + .app-main {
    padding-top: 180px;
    width: 100%;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
